import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useCart } from '../../contexts/CartContext';
import CartButton from '../../components/feature/CartButton';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [addedToCart, setAddedToCart] = useState<number | null>(null);
  const { addToCart, cartItems } = useCart();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAddToCart = (product: any, e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
    }
    addToCart(product);
    setAddedToCart(product.id);
    setTimeout(() => setAddedToCart(null), 2000);
  };

  const handleWhatsAppClick = () => {
    if (cartItems.length === 0) {
      window.open('https://wa.me/2348154358746', '_blank');
      return;
    }

    let message = '🌿 *NEW ORDER - ORGANIC NATURAL SOLUTION*\n';
    message += '━━━━━━━━━━━━━━━━━━━━━━\n\n';
    message += '📦 *ORDER DETAILS:*\n\n';
    
    cartItems.forEach((item, index) => {
      message += `${index + 1}. *${item.name}*\n`;
      message += `   • Quantity: ${item.quantity}\n`;
      message += `   • Unit Price: ₦${item.priceNumeric.toLocaleString()}\n`;
      message += `   • Subtotal: ₦${(item.priceNumeric * item.quantity).toLocaleString()}\n\n`;
    });
    
    message += '━━━━━━━━━━━━━━━━━━━━━━\n';
    message += `💰 *TOTAL AMOUNT: ₦${cartItems.reduce((sum, item) => sum + (item.priceNumeric * item.quantity), 0).toLocaleString()}*\n`;
    message += '━━━━━━━━━━━━━━━━━━━━━━\n\n';
    message += '📍 Please confirm this order and provide your delivery address.\n\n';
    message += 'Thank you for choosing Organic Natural Solution! 🌿';
    
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/2348154358746?text=${encodedMessage}`, '_blank');
  };

  const [playingVideo, setPlayingVideo] = useState<number | null>(null);

  const videoTestimonials = [
    {
      id: 1,
      thumbnail: 'https://public.readdy.ai/ai/img_res/32f391148c03ccf35b87308eccfc0f0f.jpg',
      videoUrl: 'https://drive.google.com/file/d/1821CeBCetOaTHSLWAklXiKkGkPgCh2oG/preview',
      title: 'Client testimony'
    },
    {
      id: 2,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20man%20in%20his%2050s%20sharing%20health%20success%20story%20outdoors%20natural%20sunlight%20genuine%20expression%20testimonial%20video%20screenshot%20wellness%20journey%20authentic%20documentary%20style&width=600&height=400&seq=video-testimonial-man-2&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/1_2UO_b0KY7UU-5fZtPjkga6k0X-EkNJN/preview',
      title: 'Client testimony'
    },
    {
      id: 3,
      thumbnail: 'https://readdy.ai/api/search-image?query=Nigerian%20woman%20in%20her%2030s%20happy%20expression%20sitting%20in%20modern%20office%20natural%20lighting%20testimonial%20video%20screenshot%20health%20transformation%20story%20professional%20setting%20authentic&width=600&height=400&seq=video-testimonial-woman-3&orientation=landscape',
      videoUrl: 'https://drive.google.com/file/d/14Fc1CuAzsvMSdsv1k89t6EYoSP6j59_b/preview',
      title: 'Client testimony'
    }
  ];

  const featuredProducts = [
    {
      id: 1,
      name: 'Clean Detox',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦28,000',
      priceNumeric: 28000,
      rating: 5,
      reviews: 127,
      bg: 'bg-rose-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/6e120bfc8043ea77825d5145e57e2953.jpeg',
      description: 'CLEAN DETOX CAPSULE is an age-old ayurvedic formulation. Designed to stimulate digestive fire, promote bile flow, and help in liver detoxification. Combined with Noni to reduce cholesterol and triglycerides, drop- down painful imflammationand swelling. With the addition of Gilloy, Clean Detox is effective for blood sugar control, brings down dengue fever, and is an antipyritic agent. It is useful in burning stomach fats due to the presence of Kachnar guggul, Varunchal and Choti Elaichi, helps in treating prostate enlargement and bladder sensitivity. Reduces the weight of the prostate gland and maintains urineflow. Detoxify bad breath, cleanse your whole body, and fights free radicals.DO YOU KNOW: Clean Detox will boost yourimmune system while detoxifying your viscera organs. As you experience the detoxifying effect of Clean Detox, identify how you fight against free radicals, makes you look younger, and enjoy the healing powers released on you by our age-old ayuvadic formulation, the Clean Detox',
      benefits: ['Supports liver & body detox', 'Boosts digestion & burns belly fat', 'Reduce Cholesterol & inflammation', 'Rich in antioxidants'],
      ingredients: 'Organic Turmeric Root (500mg), Black Pepper Extract (5mg), Vegetable Capsule',
      usage: 'Take 2 capsules daily with meals or as directed by your healthcare practitioner.'
    },
    {
      id: 2,
      name: 'Vita Trace',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦35,000',
      priceNumeric: 35000,
      rating: 5,
      reviews: 98,
      bg: 'bg-emerald-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/1ac0f230ef4066a4924563e20feb1190.jpeg',
      description: 'VITA TRACE (DOUBLE STEMCELL+) - An amazing combination of supplements and remedies put together makes our Double Stemcell+ a refreshing voice in the wilderness of pathological conditions. Bringing the stemcells of multiple fruits, combined with 16 Ayurvedic remedies that are designed to renew your cells, repair damaged tissues, nerve muscles, neurologic disorder, dementia, reproductive system, respiratory system, circulation system and urinary system. In a wholistic approach, Double Stemcell+ touches an every human organ and gets you completely rejuvenated. Our Double Stemcell+ has anti-inflammatory, antispasmodic and anti-depressant properties that give us the clinical laurel above any other stemcell you may have come across. DO YOU KNOW: Double Stemcell+ can be used on any form of sickness. As you enjoy the rejuvenating force behind our Double Stemcell+, observe how your complaints gradually go down and you can face the future with confidence and renewed hope.',
      benefits: ['Reduces stress and anxiety', 'Supports adrenal function', 'Improves sleep quality', 'Enhances mental clarity'],
      ingredients: 'Organic Ashwagandha Root Extract (600mg), Vegetable Capsule',
      usage: 'Take 1-2 capsules daily, preferably in the evening or as recommended by your healthcare provider.'
    },
    {
      id: 3,
      name: 'Noni Juice',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦35,000',
      priceNumeric: 35000,
      rating: 5,
      reviews: 156,
      bg: 'bg-amber-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/d02458b1e54619b28c4a092f4c0e98a0.jpeg',
      description: `NONI JUICE has been traditionally used for the treatment of inflammation, abscesses, angina, diabetes, abdominal fibroma, scorpionfish sting, cold flu, anxiety and high blood pressure. Muscle aches and pains, menstrual difficulties, headaches, heart diseases, gastric ulcers, sprains, depression, poor digestion, atherosclerosis, and circulation problems. Noni juice also reduces total cholesterol and triglyceride, reduces chronic pains and swelling. Treats parasitic infections, prevents cellular damage caused by smoking and normalizes liver function. Everhealthy Noni Juice is fortified with Brahmi, Kokum fruit, Vaivadang fruit, Alma and Aloe vera to treat Alzheimer's diseases, improve memory, attention deficit, hyperactivity disorder, allergic conditions, irritable bowel syndrome, epilepsy, prevent cancer, dysentery and constipation. Accelerates wound healing, reduce dental plagues, helps to treat cancer sores, burns, allergic reaction, rheumatoid arthritis, skin disease, pile and inflammatory conditions of the digestive system.                                                            DO YOU KNOW: Everhealthy Noni juice can be applied directly for Noni juice, discover the wholistic power that is stored in our age-old tradition Ayurveda.`,
      benefits: ['Eases digestive discomfort', 'Reduces bloating', 'Supports gut health', 'Calming and warming'],
      ingredients: 'Organic Ginger Root, Organic Fennel Seeds, Organic Peppermint Leaf',
      usage: 'Steep 1 tea bag in hot water for 5-7 minutes. Enjoy 2-3 times daily, especially after meals.'
    },
    {
      id: 4,
      name: 'FS Desire Capsule',
      subtitle: 'Trusted Ayurvedic formulation',
      price: '₦20,000',
      priceNumeric: 20000,
      rating: 5,
      reviews: 9301,
      bg: 'bg-purple-50',
      image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/1dd659f395c13bd2d90a61a82f7ae7a8.jpeg',
      description: 'FS-DESIRE CAPSULES is a special formula with anexclusive blend of 14 Ayurvedic remedies. Designed to bring back love and wholistic healing to your sexual life, clear away impotency, bring an end to premature ejaculation and improve your strength. Excellent sexrevival for hypertensive and diabetic patients, suitable for all men and women. Fortified with Ras Sindoor, Trivang Bhasma, Abhrak Bhasma, Pushapadhwa and Shilajit. Careful attention is given to ensure wholistichealing to your sexual powers. Everhealthy FS-Desire capsules will renew your sexual life with wonderful hopeyou will never forget. The Ultimate in Kama sutra!DO YOU KNOW: FS-Desire is not a stimulant. As you takeEverhealthy FS-Desire capsules, discover how powerful you become in the other room and enjoy the wholistic sexual healing that comes with our exclusive formulas,the FS-Desire',
      benefits: ['Promotes restful sleep', 'Reduces nighttime anxiety', 'Non-habit forming', 'Gentle and effective'],
      ingredients: 'Organic Chamomile Flower (400mg), Organic Lavender (200mg), Organic Passionflower (150mg)',
      usage: 'Take 2 capsules 30-60 minutes before bedtime with water.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg" 
                alt="Organic Natural Solution Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-200'}`} onClick={() => window.scrollTo(0, 0)}>Home</Link>
              <Link to="/about" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-200'}`} onClick={() => window.scrollTo(0, 0)}>About</Link>
              <Link to="/products" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-200'}`} onClick={() => window.scrollTo(0, 0)}>Products</Link>
              <Link to="/testimonials" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-200'}`} onClick={() => window.scrollTo(0, 0)}>Testimonials</Link>
              <Link to="/blog" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-200'}`} onClick={() => window.scrollTo(0, 0)}>Blog</Link>
              <Link to="/contact" className={`text-sm font-medium transition-colors ${scrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-200'}`} onClick={() => window.scrollTo(0, 0)}>Contact</Link>
              <CartButton />
            </div>
            <div className="flex md:hidden items-center gap-4">
              <CartButton />
              <button 
                className="cursor-pointer"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-900' : 'text-white'}`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg">
            <div className="px-6 py-4 space-y-4">
              <Link to="/" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Home</Link>
              <Link to="/about" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>About</Link>
              <Link to="/products" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Products</Link>
              <Link to="/testimonials" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Testimonials</Link>
              <Link to="/blog" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Blog</Link>
              <Link to="/contact" className="block text-sm font-medium text-gray-900 hover:text-teal-600 transition-colors" onClick={() => { setMobileMenuOpen(false); window.scrollTo(0, 0); }}>Contact</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/7871b01138475add5f101e758e319ecb.jpeg"
            alt="Organic Natural Solution Background"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
        </div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center">
          <div className="max-w-4xl mx-auto">
            <p className="text-xl md:text-2xl text-white mb-4 drop-shadow-lg">Healing through nature&apos;s wisdom</p>
            <h1 className="text-6xl md:text-8xl font-bold text-white mb-6 leading-tight drop-shadow-2xl">
              <span className="block">ORGANIC NATURAL SOLUTION</span>
            </h1>
            <p className="text-xl md:text-2xl text-white mb-10 leading-relaxed max-w-3xl mx-auto drop-shadow-lg font-medium">
              Discover powerful herbal solutions for diabetes, high blood pressure, ulcers, and more. 
              100% natural, scientifically backed, and trusted by thousands.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link to="/products" className="px-10 py-4 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition-all shadow-2xl text-lg whitespace-nowrap cursor-pointer hover:scale-105 transform">
                Shop Now
              </Link>
              <Link to="/about" className="px-10 py-4 bg-white/95 text-gray-900 rounded-lg font-semibold hover:bg-white transition-all shadow-2xl text-lg whitespace-nowrap cursor-pointer hover:scale-105 transform">
                Learn More
              </Link>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-white/70 rounded-full animate-bounce"></div>
          </div>
        </div>
      </section>

      {/* FREE Health Screening Banner */}
      <section className="py-6 bg-teal-600">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left">
            <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full flex-shrink-0">
              <i className="ri-heart-pulse-line text-2xl text-teal-600"></i>
            </div>
            <div className="text-white">
              <h3 className="text-2xl font-bold mb-1">FREE COMPUTERIZED HEALTH SCREENING</h3>
              <p className="text-teal-50 text-lg">Available at our facility - Book your appointment today!</p>
            </div>
            <Link to="/contact" className="bg-white text-teal-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
              Book Now
            </Link>
          </div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Our herbs, our life.</h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            We believe in the healing power of nature. Every product we create is a testament to our commitment to quality, purity, and your well-being. From seed to supplement, we ensure that only the finest herbal ingredients make it into your hands.
          </p>
        </div>
      </section>

      {/* Featured Products */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-end justify-between mb-12">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">
                Best Sellers <span className="text-teal-600"></span>
              </h2>
              <p className="text-gray-600">Carefully crafted herbal solutions for modern wellness</p>
            </div>
            <span className="hidden md:inline-block bg-gray-900 text-white px-6 py-2 rounded-full text-sm font-medium whitespace-nowrap">
              New Arrivals
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {featuredProducts.map((product) => (
              <div 
                key={product.id} 
                className={`${product.bg} rounded-3xl overflow-hidden group cursor-pointer transition-all duration-300 hover:shadow-xl`}
                onClick={() => setSelectedProduct(product)}
              >
                <div className="aspect-square p-6 flex items-center justify-center">
                  <img src={product.image} alt={product.name} className="w-full h-full object-contain" />
                </div>
                <div className="bg-white p-6">
                  <p className="text-sm text-gray-500 mb-1">{product.subtitle}</p>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{product.name}</h3>
                  <div className="flex items-center justify-between">
                    <div className="flex flex-col">
                      <span className="text-sm text-gray-400 line-through">
                        ₦{Math.round(parseFloat(product.price.replace(/[^0-9.]/g, '')) * 1.15).toLocaleString()}
                      </span>
                      <span className="text-2xl font-bold text-gray-900">{product.price}</span>
                    </div>
                    <button 
                      className={`w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 ${
                        addedToCart === product.id 
                          ? 'bg-teal-600 text-white' 
                          : 'bg-gray-900 text-white hover:bg-teal-600'
                      }`}
                      onClick={(e) => handleAddToCart(product, e)}
                    >
                      <i className={`${addedToCart === product.id ? 'ri-check-line' : 'ri-shopping-cart-line'}`}></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link to="/products" className="inline-block bg-gray-900 text-white px-10 py-4 rounded-full font-medium hover:bg-teal-600 transition-colors whitespace-nowrap">
              View All Products
            </Link>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Explore Our Videos Logs</h2>
            <p className="text-lg text-gray-600">Watch how our natural solutions transform lives</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {videoTestimonials.map((video) => (
              <div key={video.id} className="bg-stone-50 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                {playingVideo === video.id ? (
                  <div className="aspect-video">
                    <iframe
                      width="100%"
                      height="100%"
                      src={video.videoUrl}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                ) : (
                  <div 
                    className="aspect-video relative cursor-pointer group"
                    onClick={() => setPlayingVideo(video.id)}
                  >
                    <img 
                      src={video.thumbnail} 
                      alt={video.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/30 flex items-center justify-center group-hover:bg-black/40 transition-colors">
                      <div className="w-16 h-16 flex items-center justify-center bg-teal-600 rounded-full group-hover:scale-110 transition-transform">
                        <i className="ri-play-fill text-3xl text-white"></i>
                      </div>
                    </div>
                  </div>
                )}
                <div className="p-4">
                  <h3 className="font-semibold text-gray-900 mb-1">{video.title}</h3>
                  <p className="text-sm text-gray-600">Real customer testimonial</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Elements */}
      <section className="py-20 bg-teal-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="inline-block bg-white px-6 py-2 rounded-full text-sm font-medium text-gray-900 mb-4">Our Promise</span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              Pure Ingredients,<br />Proven Results
            </h2>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {[
              { icon: 'ri-leaf-line', title: 'Organic Certified' },
              { icon: 'ri-flask-line', title: 'Lab Tested' },
              { icon: 'ri-plant-line', title: 'Sustainably Sourced' },
              { icon: 'ri-heart-line', title: 'Family Owned' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-600 text-white rounded-full mx-auto mb-4">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900">{item.title}</h3>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { number: '10,000+', label: 'Happy Customers' },
              { number: '40+', label: 'Herbal Blends' },
              { number: '15 Years+', label: 'Experience' },
              { number: '100%', label: 'Natural' }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-5xl md:text-6xl font-bold text-teal-600 mb-2">{stat.number}</div>
                <p className="text-sm text-gray-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Customer Testimonials Preview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-start justify-between mb-12">
            <div>
              <p className="text-sm text-gray-500 mb-2">What Our Community Says</p>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
                Real Results,<br />
                <span className="italic font-serif">Real People</span>
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { 
                rating: 5, 
                image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/feabddfbf423c1f085427c9431bfd056.jpeg',
                text: 'After using our natural products for just 3 weeks, I feel more energized and my digestion has improved significantly. Highly recommend!'
              },
              { 
                rating: 5, 
                image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/c6509fd222724a7f0b3c9e3e08452b1c.jpeg',
                text: 'These herbal remedies have been a game-changer for my overall wellness. I notice better focus and sustained energy throughout the day.'
              },
              { 
                rating: 5, 
                image: 'https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/d5eba61c664314f682de6e9764e87e15.jpeg',
                text: 'The products taste great and I\'ve seen improvements in my joint pain. Natural products that actually work!'
              }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                <div className="aspect-[4/5]">
                  <img src={testimonial.image} alt="Client Testimonial" className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-6">
                  <p className="text-sm text-gray-600 mb-4">Client testimonial after taking our natural products</p>
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-500 text-lg"></i>
                    ))}
                  </div>
                  <p className="text-gray-600 leading-relaxed text-sm">{testimonial.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link to="/testimonials" className="inline-block bg-gray-900 text-white px-10 py-4 rounded-full font-medium hover:bg-teal-600 transition-colors whitespace-nowrap">
              Read More Stories
            </Link>
          </div>
        </div>
      </section>

      {/* Educational Content Preview */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="rounded-3xl overflow-hidden mb-12">
            <img 
              src="https://readdy.ai/api/search-image?query=authentic Nigerian herbal medicine preparation scene traditional healer with fresh organic herbs mortar and pestle natural ingredients on wooden table warm sunlight through window cultural heritage natural wellness real documentary style photography" 
              alt="Our Herbal Wellness Journey" 
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="text-center max-w-3xl mx-auto">
            <p className="text-3xl md:text-4xl leading-relaxed mb-12">
              Learn the <strong className="font-bold text-gray-900">ancient wisdom</strong> of <em className="italic text-gray-500">herbal healing</em> through our <strong className="font-bold text-gray-900">expert guides</strong> and <em className="italic text-gray-500">wellness resources</em>
            </p>
            <Link to="/blog" className="inline-block bg-black text-white px-12 py-4 rounded-full font-medium hover:bg-gray-900 transition-colors whitespace-nowrap">
              Explore Articles
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-teal-600">
        <div className="max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Start Your Wellness Journey Today</h2>
          <p className="text-xl mb-8 text-teal-50">
            Join thousands of satisfied customers who have transformed their health naturally
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/products" className="bg-white text-teal-600 px-10 py-4 rounded-full font-medium hover:bg-gray-100 transition-colors whitespace-nowrap">
              Shop Now
            </Link>
            <Link to="/contact" className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-full font-medium hover:bg-white/10 transition-colors whitespace-nowrap">
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div>
              <img src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/8e2a19642137d9fb9670ecec43a2e980.jpeg" alt="Organic Natural Solution Logo" className="h-12 w-auto mb-6" />
              <p className="text-gray-400 leading-relaxed mb-6">
                Dedicated to providing the highest quality herbal remedies that honor traditional wisdom while meeting modern wellness needs.
              </p>
              <div className="flex gap-4">
                <a href="https://www.instagram.com/healthyliving.products?igsh=NGl6a3oxZXhrcmxr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="https://www.facebook.com/share/1CKjLukjVr/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-full hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
              </div>
            </div>

            <div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">LOCATION</h4>
                <p className="text-gray-400">#2 Allen Avenue Near Tonyin Roundabout, Ikeja, Lagos - Nigeria</p>
              </div>
              <div className="mb-8">
                <h4 className="text-xs font-bold uppercase mb-3">PHONE</h4>
                <p className="text-gray-400">+234 815 435 8746</p>
                <p className="text-gray-400">+234 913 789 7299</p>
              </div>
              <div>
                <h4 className="text-xs font-bold uppercase mb-3">EMAIL</h4>
                <p className="text-gray-400">healthyliving.hello@gmail.com</p>
              </div>
            </div>

            <div>
              <div className="rounded-2xl overflow-hidden h-80">
                <img 
                  src="https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/6686b80771a03e2f4f8c9b19d31144a1.jpeg" 
                  alt="Organic Natural Solution" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8">
            <p className="text-sm text-gray-400 text-center">© 2025 Organic Natural Solution. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center z-50 transition-all hover:scale-110 cursor-pointer"
        aria-label="Contact us on WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </button>

      {/* Quick View Popup */}
      {selectedProduct && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setSelectedProduct(null)}>
          <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-gray-900">Product Details</h2>
              <button onClick={() => setSelectedProduct(null)} className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors cursor-pointer">
                <i className="ri-close-line text-2xl text-gray-900"></i>
              </button>
            </div>

            <div className="p-6 md:p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className={`${selectedProduct.bg} rounded-3xl p-8 flex items-center justify-center`}>
                  <img src={selectedProduct.image} alt={selectedProduct.name} className="w-full h-auto object-contain" />
                </div>

                <div>
                  <p className="text-sm text-gray-500 mb-2">{selectedProduct.subtitle}</p>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">{selectedProduct.name}</h3>
                  
                  <div className="flex items-center gap-3 mb-6">
                    <div className="flex gap-1">
                      {[...Array(selectedProduct.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-500 text-lg"></i>
                      ))}
                    </div>
                    <span className="text-gray-600">({selectedProduct.reviews} reviews)</span>
                  </div>

                  <div className="mb-6">
                    <span className="text-xl text-gray-400 line-through mr-3">
                      ₦{Math.round(parseFloat(selectedProduct.price.replace(/[^0-9.]/g, '')) * 1.15).toLocaleString()}
                    </span>
                    <span className="text-4xl font-bold text-gray-900">{selectedProduct.price}</span>
                  </div>

                  <p className="text-gray-600 leading-relaxed mb-6">{selectedProduct.description}</p>

                  <div className="flex gap-4">
                    <button 
                      className={`flex-1 px-8 py-4 rounded-full font-medium transition-all duration-300 whitespace-nowrap ${
                        addedToCart === selectedProduct.id
                          ? 'bg-teal-600 text-white'
                          : 'bg-gray-900 text-white hover:bg-teal-600'
                      } cursor-pointer`}
                      onClick={() => {
                        handleAddToCart(selectedProduct);
                        setTimeout(() => setSelectedProduct(null), 1500);
                      }}
                    >
                      {addedToCart === selectedProduct.id ? (
                        <span className="flex items-center justify-center gap-2">
                          <i className="ri-check-line"></i>
                          Added to Cart
                        </span>
                      ) : (
                        'Add to Cart'
                      )}
                    </button>
                    <button className="w-14 h-14 flex items-center justify-center border-2 border-gray-900 rounded-full hover:bg-gray-100 transition-colors cursor-pointer">
                      <i className="ri-heart-line text-xl text-gray-900"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
